import type {ISubtitleState} from "../../reducers/createNewProjectReducer.ts";

export const isLanguagesStepValid = (subtitles: ISubtitleState): boolean => {
  const hasSourceLanguage: boolean = Object.keys(subtitles.sourceLanguage).length === 1;
  if (!hasSourceLanguage) return false;
  if (subtitles.isTranscribeOnly) return true;
  return Object.keys(subtitles.targetLanguages).length >= 1;
};
